import React from 'react';

import { markdown } from 'markdown';
import parse from 'html-react-parser';


export const Markdown = ({children, ...domProps}) => {
    const html = markdown.toHTML(children);

    if (!children) {
        return '';
    }

    try {
        return (
            <div {...domProps}>
                {parse(html)}
            </div>
        );
    } catch(e) {
        console.log("Markdown rendering failed.", e);
        return '';
    }
};

export default Markdown;
